
import { put, call, takeLatest, all, fork } from "redux-saga/effects";
import { apiCallFailure, apiCallSuccess } from "../Action/Action";
import * as dashboardAPI from '../../services/DashboardAPI';
import * as types from "../Action/actionTypes";
function* saveDocumentOutcomePage(data: any): Generator {
    try {
        const response: any = yield call(dashboardAPI.saveDocumentOutcome, data)
        if (response.status === 200) {
            yield put(apiCallSuccess("Response saved successfully"));
            yield put({ type: types.SAVE_DOCUMENT_OUTCOME_SUCCESS, payload: response.result });
            if (data.meta?.onSuccess) {
                data.meta.onSuccess()
            }

        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while saving your response. Please try again."
                )
            );
            yield put({ type: types.SAVE_DOCUMENT_OUTCOME_FAILURE, payload: "" });
            if (data.meta?.onFailure) {
                data.meta.onFailure()
            }
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while saving your response. Please try again."
            )
        );

        yield put({ type: types.SAVE_DOCUMENT_OUTCOME_FAILURE, payload: e });
        if (data.meta?.onFailure) {
            data.meta.onFailure()
        }
    }
}
function* saveReviewNegotiation(data: any): Generator {
    try {
        const response: any = yield call(dashboardAPI.saveReviewNegotiation, data)
        if (response.status === 200) {
            yield put(apiCallSuccess("Review saved successfully"));
            yield put({ type: types.SAVE_REVIEW_NEGOTIATION_DATA_SUCCESS, payload: response.result });
            if (data.meta?.onSuccess) {
                data.meta.onSuccess()
            }
        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while saving Review. Please try again."
                )
            );
            yield put({ type: types.SAVE_REVIEW_NEGOTIATION_DATA_FAILURE, payload: "" });
            if (data.meta?.onFailure) {
                data.meta.onFailure()
            }
        }
    } catch (e) {
        yield put(
            apiCallFailure(
                "An error occurred while saving review. Please try again."
            )
        );
        yield put({ type: types.SAVE_REVIEW_NEGOTIATION_DATA_FAILURE, payload: e });
        if (data.meta?.onFailure) {
            data.meta.onFailure()
        }
    }
}

function* watchSaveReviewNegotiationData(): Generator {
    yield takeLatest(types.SAVE_REVIEW_NEGOTIATION_DATA, saveReviewNegotiation)
}
function* watchSaveDocumentOutcome(): Generator {
    yield takeLatest(types.SAVE_DOCUMENT_OUTCOME, saveDocumentOutcomePage)
}
export function* DocumentOutcomeSaga(): Generator {
    yield all([
        fork(watchSaveDocumentOutcome),
        fork(watchSaveReviewNegotiationData)
    ])
}